import gql from 'graphql-tag'

export const GET_SENSOR_PAGINATED = gql`
  query SensorsPaginated($filter: GetSensorsFilter) {
    sensorsPaginated(filter: $filter) {
      sensorsPaginated {
        data {
          vehicleId
          vehicleType {
            category
            type
          }
          vehicleGroup {
            id
            companyId
            name
          }
          vehicle {
            licensePlate
            imei
            fuelCapacity
          }
          sensorCode
          pinCode
          rangeLo
          rangeHi
          alertLo
          alertHi
          alertIdleLo
          alertIdleHi
          requireEngine
          id
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const UPDATE_SENSOR_PAGINATED = gql`
  mutation UpdateSensors($input: UpdateSensorsInput!) {
    updateSensors(input: $input) {
      errorCode
      errorName
      isSuccessful
      message
    }
  }
`
